let language = {
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_PAYPAL_INTRO_TIP: "PayPal 接受所有主要信用卡。您无需拥有 Paypal 帐户即可使用此付款方式。",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_PAYPAL_AUTO_TIP:"为您的 {{appName}} 帐户添加主要结算方式，这将是我们向您收取未来交易费用的默认方式。",
    BULK_ORDER_CHECKOUT_STEP_BANK_TRANSFER_TIP:"若要付款，请点击\“{{payBtnText}}\”并按照转账指示进行操作。",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_CHECKOUT_WATING_TIP_TITLE: "稍等片刻",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_CHECKOUT_WATING_TIP_CONTENT: "我们正在努力创建您的订单。虽然这可能需要一些时间，但感谢您的耐心，请不要关闭此页面，直到流程完成。"
};

export { language }